import React from "react";
import axios from "axios";
import { emailVerificationURL } from "../utils/constants";
import {
    sendVerifyEmailStart,
    sendVerifyEmailSuccess,
    sendVerifyEmailError,
} from "../actions/signupActions";
import { contactSupport } from "../utils/links";
import { message } from "antd";

const sendVerifyEmail = async (email, dispatch) => {
    dispatch(sendVerifyEmailStart());
    try {
        const result = await axios.post(emailVerificationURL, { email: email });
        dispatch(sendVerifyEmailSuccess());
        message.success("Verification email sent. Please check your inbox.");
        return result;
    } catch (error) {
        const errorDisplay = (
            <span>
                    {
                        "Sorry, there was an error resending your verification email, please contact "
                    }
                {contactSupport}
            </span>
        );
        dispatch(sendVerifyEmailError(errorDisplay));
        message.error(errorDisplay);
        console.log(error);
    }
};

export { sendVerifyEmail };
